import { Outlet } from "react-router-dom";
import Spinner from "./Spinner.js";
export default function AuthProtected({ ok }) {
    return ok ? <Outlet /> : <Spinner />;
}
